import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './components/LandingPage';
import JavaPage from './components/JavaPage';
import DbmsPage from './components/DbmsPage';
import PythonPage from './components/PythonPage';
import OsPage from './components/OsPage';
import CnPage from './components/CnPage';
import MlPage from './components/MlPage';
import AiGenaiPage from './components/AiGenaiPage';
import TopicPage from './components/TopicPage';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-50">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/java" element={<JavaPage />} />
          <Route path="/java/:topic" element={<TopicPage />} />
          <Route path="/dbms" element={<DbmsPage />} />
          <Route path="/dbms/:topic" element={<TopicPage />} />
          <Route path="/python" element={<PythonPage />} />
          <Route path="/python/:topic" element={<TopicPage />} />
          <Route path="/os" element={<OsPage />} />
          <Route path="/os/:topic" element={<TopicPage />} />
          <Route path="/cn" element={<CnPage />} />
          <Route path="/cn/:topic" element={<TopicPage />} />
          <Route path="/ml" element={<MlPage />} />
          <Route path="/ml/:topic" element={<TopicPage />} />
          <Route path="/ai-genai" element={<AiGenaiPage />} />
          <Route path="/ai-genai/:topic" element={<TopicPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
